export const agencyName = 'Mythic Digital';
export const agencyUrl = 'https://mythic.digital';
export const agencyEmail = 'hello@mythic.digital';

export const callingCardLead = `Designed & developed by ${agencyName}`;

export const callingCardHtmlComment = `
  ${callingCardLead}
  ${agencyUrl}
  ${agencyEmail}
`;

export const callingCardConsoleTitle = callingCardLead;
export const callingCardConsoleBody = `${agencyUrl}\n${agencyEmail}`;
